
import type { PropType } from 'vue'
import type { InstanceManagementMessages } from '../../models'
import { defineComponent } from 'vue'
import { EpbButton } from '../shared/epb-button'
import { EpbSwitch } from '../shared/epb-switch'

export default defineComponent({
  name: 'ServiceConfigActionsBar',
  components: {
    EpbButton,
    EpbSwitch,
  },
  props: {
    saveActionDisabled: {
      type: Boolean,
      default: false,
    },
    enabled: {
      type: Boolean,
    },
    setEnabledActionDisabled: {
      type: Boolean,
      default: false,
    },
    setEnabledActionHidden: {
      type: Boolean,
      default: false,
    },
    messages: {
      type: Object as PropType<InstanceManagementMessages['serviceConfig']['actions']>,
      required: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-service-config-actions-bar',
    }
  },
})
